import { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// 15 minutes in milliseconds
const IDLE_TIMEOUT = 15 * 60 * 1000;

const useAutoLogout = () => {
  const { logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const clearTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);

  const handleLogout = useCallback(() => {
    logout();
    navigate('/admin/login', { replace: true });
  }, [logout, navigate]);

  const resetTimer = useCallback(() => {
    clearTimer();
    if (isAuthenticated) {
      timeoutRef.current = setTimeout(handleLogout, IDLE_TIMEOUT);
    }
  }, [clearTimer, handleLogout, isAuthenticated]);

  useEffect(() => {
    resetTimer();

    const events = ['mousemove', 'mousedown', 'keypress', 'touchstart', 'scroll'];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    return () => {
      clearTimer();
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [resetTimer, clearTimer]);
};

export default useAutoLogout;

